import React from 'react';
import PropTypes from 'prop-types';

import ConversationItem from 'models/conversation_item';
import WavePlayer from 'components/lib/audio/wave_player';
import { createWavePlayerContainer } from './lib/create_wave_player_container';

const VoiceAIRecordingWavePlayerContainer = createWavePlayerContainer({
  propTypes: {
    item: PropTypes.instanceOf(ConversationItem).isRequired,
  },

  renderVoiceRecordingContainer() {
    let voiceAiRecordingItemContent = this.props.item.content;
    let baseUrl = this.getBaseRecordingUrl();
    let url = `${baseUrl}/voice-ai-recordings/${voiceAiRecordingItemContent.recordingId}`;

    let props = {
      duration: voiceAiRecordingItemContent.recordingDuration,
      onReady: this.saveRecordingDuration,
      recordingId: voiceAiRecordingItemContent.recordingId,
      url,
      customerId: this.props.item.customerId,
      contentType: this.props.item.contentType(),
      disabled: this.isPlayerDisabled(),
    };

    return <WavePlayer {...props} />;
  },
});

export default VoiceAIRecordingWavePlayerContainer;
